import { TReduxActions } from '../../types/redux';
import { EPikDataActionTypes } from '../../actions/pikData';
import { IPikData } from '../../../typings/api';

export function pikDataReducer(state: IPikData | null = null, action: TReduxActions) {
  if (action.type === EPikDataActionTypes.SetPikData) {
    return {
      ...action.payload,
    };
  }

  return state;
}
